export default __webpack_public_path__ + "static/media/runicon.cc5406ba.svg";